import {Component} from '@angular/core';
import {SmartModalService} from 'app/core/services/smart-modal.service';
import {ConfigService} from 'app/core/services/config.service';
import {Subject} from 'rxjs/Subject';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {RxComponent} from 'app/core/components/common/rx.component';

@Component({
    selector: 'itpx-silk-add-image',
    templateUrl: './add-image.component.html',
    styleUrls: ['./add-image.component.css']
})
export class AddImageComponent extends RxComponent {

    bucket: string;
    imageSaved$ = new ReplaySubject();
    insertClicked$ = new Subject();

    constructor(private modalService: SmartModalService,
                private configService: ConfigService) {
        super();
        this.bucket = this.configService.get('aws').uploadsBucket;
    }

    ngOnInit() {

        this.insertClicked$
            .withLatestFrom(this.imageSaved$, (_, url) => url)
            .bindToLifecycle(this)
            .subscribe(data => this.modalService.sendResult(data));
    }

    onSaved(e) {
        const {path, key, bucket} = e.data;
        this.imageSaved$.next({src: path, key, bucket});
    }

    onInsertClick() {
        this.insertClicked$.next();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/silk/toolbars/standard-toolbar/add-image/add-image.component.ts